import RouterView from '@/components/RouterView'
import TryoutList from './TryoutList'
import TryoutDetail from './TryoutDetail'

export default [
    {
        path: 'tryout',
        component: RouterView,
        children: [
            { path: '', component: TryoutList, name: 'tryout', meta: { title: 'Tryout' } },
            { path: ':hash', component: TryoutDetail, name: 'tryout.prestart', meta: { analyticsIgnore: true } },
        ]
    }
]
